import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="sub-page">
      <div className="sub-page__container">
        <h2>Privacy Policy for Eleganto</h2>

        <h4 className="h4">Data Collection</h4>
        <p className="text">
          We collect personal information such as name, surname, email, and phone number for the purpose of booking
          appointments. We also use Google Analytics, Facebook Pixel, and Clarity for web analytics.
        </p>

        <h4 className="h4">Cookies</h4>
        <p className="text">
          We use cookies in compliance with Google Consent Mode v2 to enhance user experience and analyze site usage.
        </p>

        <h4 className="h4">Data Use</h4>
        <p className="text">
          The collected data is used for booking appointments, improving service delivery, and targeted advertising
          through GA4, Google Ads, and Facebook based on user consent.
        </p>

        <h4 className="h4">Data Sharing</h4>
        <p className="text">
          Collected data may be shared with GA4, Google Ads, Facebook, and Clarity for analytics and advertising
          purposes.
        </p>

        <h4 className="h4">Data Protection</h4>
        <p className="text">
          User data is securely stored on Google Cloud Storage. We implement robust security measures to protect your
          information from unauthorized access, alteration, or destruction.
        </p>

        <h4 className="h4">User Rights</h4>
        <p className="text">
          Users have the right to access, correct, or delete their personal information. Users can also opt-out of data
          collection by managing their cookie preferences.
        </p>

        <h4 className="h4">Changes to the Policies</h4>
        <p className="text">
          We may update these policies from time to time. Users will be notified of any changes via email and are
          entitled to opt-out of certain changes.
        </p>

        <h4 className="h4">Contact Information</h4>
        <p className="text">
          For any questions, concerns, or comments about our Terms of Use or Privacy Policy, please contact us through
          our website's contact form or via the support section in our web application.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
